export default __webpack_public_path__ + "static/media/entity-assessment.2ca8ac1c.png";